<template>
  <bdg-input-template @focusout="onFocusout">
    <bdg-text-field
      ref="address1"
      name="Address line 1"
      v-model="address_1"
      :disabled="disabled"
      :required="required"
    />

    <bdg-text-field
      name="Address line 2"
      v-model="address_2"
      :disabled="disabled"
    />

    <bdg-text-field
      ref="city"
      name="City"
      v-model="city"
      :disabled="disabled"
      :required="required"
    />

    <div class="flex flex-row justify-between items-center mt-4">
      <bdg-text-field
        ref="state"
        class="w-1/2"
        name="State"
        v-model="state"
        :disabled="disabled"
        :required="required"
      />

      <bdg-text-field
        ref="zip"
        class="w-1/2"
        name="Zip code"
        v-model="zip"
        :disabled="disabled"
        :required="required"
      />
    </div>
  </bdg-input-template>
</template>

<script>
import BdgInputTemplate from "./BdgInputTemplate";
import { Place } from "../../models/Place";
import BdgTextField from "./BdgTextField";
import { validateRequiredRefs } from "../../helpers";

export default {
  name: "BdgAddressFields",
  extends: BdgInputTemplate,
  components: { BdgTextField, BdgInputTemplate },
  props: {
    value: { type: Place, default: () => new Place() },
    disabled: Boolean
  },
  data() {
    return {
      requiredRefs: ["address1", "city", "state", "zip"]
    };
  },
  computed: {
    address_1: {
      get() {
        return this.value.address_1;
      },
      set(val) {
        this.$emit("input", this.value.assignProp("address_1", val));
      }
    },
    address_2: {
      get() {
        return this.value.address_2;
      },
      set(val) {
        this.$emit("input", this.value.assignProp("address_2", val));
      }
    },
    city: {
      get() {
        return this.value.city;
      },
      set(val) {
        this.$emit("input", this.value.assignProp("city", val));
      }
    },
    state: {
      get() {
        return this.value.state;
      },
      set(val) {
        this.$emit("input", this.value.assignProp("state", val));
      }
    },
    zip: {
      get() {
        return this.value.zip;
      },
      set(val) {
        this.$emit("input", this.value.assignProp("zip", val));
      }
    }
  },
  methods: {
    validate() {
      return validateRequiredRefs(this);
    },
    onFocusout() {
      this.isInvalid = this.required && !this.validate();
    }
  }
};
</script>

<style scoped></style>
